export default __webpack_public_path__ + "static/media/headphonesCC.dd3568dd.jpg";